export default __webpack_public_path__ + "static/media/BgGroup38520.00b2299f.png";